export const NavData = [
  {
    title: "Home",
    path: "/Home",
  },
  {
    title: "About Us",
    path: "/Home/About_Us",
  },
  {
    title: "Cources",
    path: "#",
    subNav: [
      {
        subTitle: "Courses",
        heading: " Pick a Course to Get Started ",
        path: "/Home/Courses",
      },
      {
        subTitle: "Course Details",
        heading: "Complete Advance Management Study",
        path: "/Home/Courses/Course_Details",
      },
    ],
  },
  {
    title: "Pages",
    path: "#",
    subNav: [
      {
        subTitle: "Our Team",
        heading: "Troostudy’s Best Instructor",
        path: "/Home/Our_Team",
      },
      {
        subTitle: "Teastimonial",
        heading: "What Say students About Us",
        path: "/Home/Teastimonial",
      },
      {
        subTitle: "FAQs",
        heading: "Most Asked Questions",
        path: "/Home/FAQs",
      },
      {
        subTitle: "404 Error",
        heading: "Error Page",
        path: "/Home/404_Error",
      },
      {
        subTitle: "Comming Soon",
        heading: "Comming Soon",
        path: "/Home/Comming_Soon",
      },
      {
        subTitle: "Events",
        heading: "What's Coming Up ?",
        path: "/Home/Events",
      },
      {
        subTitle: "Event Details",
        heading: "Bond Twenty Minutes Still Meditation In",
        path: "/Home/Events/Event_Details",
      },
      {
        subTitle: "Carrier",
        heading: "Featured Job Offers",
        path: "/Home/Carrier",
      },
      {
        subTitle: "Carrier Details",
        heading: "Yoga Teacher",
        path: "/Home/Carrier/Carrier_Details",
      },
    ],
  },
  {
    title: "Blogs",
    path: "#",
    subNav: [
      {
        subTitle: "Blogs",
        heading: "Read Our Latest News & Blogs",
        path: "/Home/Blogs",
      },
      {
        subTitle: "Blog List",
        heading: "Read Our Latest News & Blogs",
        path: "/Home/Blog_List",
      },
      {
        subTitle: "Blog Details",
        heading: "25 Essential High School Reads From the Last Decade",
        path: "/Home/Blogs/Blog_Details",
      },
    ],
  },
  {
    title: "Contact Us",
    path: "/Home/Contact_Us",
  },
  {
    title: "Apply Now",
    path: "/Home/Apply_Now",
  },
];
